import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { CLIENT_AVATAR_ROUTE_IDS, ORG_USER_CLIENT_BASELINE_MODULES, } from './presets.js';
export const ORGANIZATION_CLIENT_ACCESS_PROFILE = {
    persona: 'ORG_CLIENT',
    actorTypes: ['CLIENT'],
    scope: {
        allowedKinds: ['CLIENT'],
        defaultKind: 'CLIENT',
        organizationRequired: true,
        branchRequired: false,
        clientRequired: true,
        ownershipPolicy: 'OWN_CLIENT',
    },
    authentication: {
        defaultAal: 'AAL1',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [ROUTE_IDS.DASHBOARD, ROUTE_IDS.REPORTS],
        avatarRouteIds: CLIENT_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: [
            ROUTE_IDS.ADMIN_HUB,
            ROUTE_IDS.PLATFORM_ADMIN_HUB,
            ROUTE_IDS.ORGANIZATION_ADMIN_HUB,
            ROUTE_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE,
            ROUTE_IDS.DATA_HUB,
            ROUTE_IDS.TRANSACTION_CREATE,
            ROUTE_IDS.TRANSACTION_APPROVALS,
            ROUTE_IDS.TRANSACTION_REVERSALS,
            ROUTE_IDS.DATA_INSTRUMENTS,
            ROUTE_IDS.DATA_IMPORTS,
            ROUTE_IDS.DATA_RECONCILIATION,
            ROUTE_IDS.DATA_CORPORATE_ACTIONS,
            ROUTE_IDS.DATA_FACT_BATCHES,
            ROUTE_IDS.DATA_HOLDINGS,
            ROUTE_IDS.ORGANIZATION_USERS_LIST,
            ROUTE_IDS.ORGANIZATION_ROLES_LIST,
            ROUTE_IDS.ORGANIZATION_PROFILE,
            ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
            ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_LIST,
            ROUTE_IDS.PLATFORM_USERS_LIST,
            ROUTE_IDS.PLATFORM_MODULES_LIST,
            ROUTE_IDS.PLATFORM_AUDIT_LIST,
            ROUTE_IDS.SETTINGS_MFA,
        ],
    },
    access: {
        defaultOperationBundleIds: ['client-self-service'],
        allowedOperationBundleIds: ['client-self-service'],
    },
    modules: {
        baseline: ORG_USER_CLIENT_BASELINE_MODULES,
        optional: ['HOLDINGS'],
        forbidden: ['PLATFORM', 'ADMIN', 'ACCOUNTING', 'TAX', 'RECONCILIATION', 'CORPORATE_ACTIONS', 'IMPORT', 'INSTRUMENTS', 'FACTS', 'MARGIN_TRADING', 'ORDER_MANAGEMENT', 'DATA'],
    },
    administration: { resourceIds: [] },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: false,
        maySelectClient: false,
        maySelectPortfolio: false,
    },
    delegation: {
        mayInitiate: false,
        mayReceive: false,
        organizationDataRequiresDelegation: false,
    },
    mutationPolicy: 'READ_ONLY',
};
